const Notion = () => {
  const externalLink = 'https://ag-ace.notion.site/ag-ace/Association-des-Cercles-Etudiants-ULB-25585d934609447e959b9cc6d6d6f8b0';

  window.location.href = externalLink;

  return null;
};

export default Notion;
